<template>
  <div
    class="bar mb-1"
    :class="{ 'bar--empty': empty }"
    :style="style"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <transition name="fade">
      <div v-if="!empty && hover" class="bar-tooltip">
        <div class="bar-tooltip__content">
          <div class="bar-tooltip__title">{{ tooltip }}</div>
        </div>
      </div>
    </transition>
    <div v-if="empty" class="inner-text">{{ translations('dashboard.no_performance_data') }}</div>
  </div>
</template>

<script>
import { lightenColor } from '@/common/color'
import { mapState } from 'vuex'

export default {
  name: 'DashboardRevenueBar',

  props: {
    name: {
      type: String,
      required: true
    },
    percentage: {
      type: [Number, String],
      required: true
    },
    color: {
      type: String,
      required: true
    },
    empty: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      hover: false
    }
  },

  computed: {
    ...mapState(['currentLanguage']),
    lighterColor () {
      return lightenColor(this.color)
    },

    style () {
      if (this.empty) return {}

      return {
        width: `${this.percentage}%`,
        backgroundColor: this.hover ? this.lighterColor : this.color,
        display: 'block'
      }
    },

    tooltip () {
      return `${this.name} - ${this.percentage}%`
    }
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    }
  }
}
</script>

<style scoped>
.bar {
  position: relative;
  z-index: 2;
  height: 21px;
  cursor: pointer;
  transition: 0.3s ease;
}

.bar.bar--empty {
  border: 1px solid #e8e8e8;
  border-width: 1px 0;
  width: 100%;
  cursor: unset;
  background: repeating-linear-gradient(45deg, #f3f3f3, #f3f3f3 3%, white 3%, white 6%);
}

.bar.bar--empty .inner-text {
  font-size: 10px;
  line-height: 21px;
  text-align: center;
  color: #888;
}

.bar-tooltip {
  pointer-events: none;
  position: relative;
}

.bar-tooltip .bar-tooltip__content {
  position: absolute;
  bottom: calc(100% + 4px);
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  padding: 2px 4px;
  border-radius: 2px;
  font-size: 10px;
  color: white;
  text-align: center;
  min-width: 140px;
  max-width: 250px;
  word-break: break-word;
  box-shadow: 0px 4px 8px 2px rgba(0, 0, 0, 0.2);
}

.bar-tooltip .bar-tooltip__content::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid rgba(0, 0, 0, 0.8);
}
</style>
